const DB_NAME = "RegistrationCustomerJourneyDB";
const DB_VERSION = 1;
const STORE_NAME = "items";

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

export const IndexedDb = {
  storeItem: async (item: unknown): Promise<string> => {
    const db = await openDB();
    const id = `item_${Date.now()}_${Math.random().toString(36).substring(7)}`;

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.put(item, id);

      request.onsuccess = () => resolve(id);
      request.onerror = () => reject(request.error);
    });
  },

  getItem: async <T>(id: string): Promise<T | null> => {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], "readonly");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(id);

      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(request.error);
    });
  },

  deleteItem: async (id: string): Promise<void> => {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.delete(id);

      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  },

  cleanupOrphanedItems: async (itemIds: Set<string>): Promise<void> => {
    try {
      const db = await openDB();
      const transaction = db.transaction([STORE_NAME], "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.getAllKeys();

      request.onsuccess = () => {
        const allKeys = request.result as string[];
        allKeys.forEach((key) => {
          if (!itemIds.has(key)) {
            IndexedDb.deleteItem(key).catch((e) =>
              console.error("Failed to delete orphaned item:", e)
            );
          }
        });
      };
    } catch (e) {
      console.error("Failed to cleanup orphaned items:", e);
    }
  },
};
